import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { WatchlistResolver } from '@planone/bau365/data-access-user';
import { Bau365FeatureBreadcrumbModule, BreadcrumbHelper } from '@planone/bau365/feature-breadcrumb';
import { Bau365FeatureExportModule } from '@planone/bau365/feature-export';
import { Bau365UiDateformattingModule } from '@planone/bau365/ui-dateformatting';
import { Bau365UiShellModule } from '@planone/bau365/ui-shell';
import { SharedUtilFeatureFlagsModule } from '@planone/shared/data-access-feature-flags';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { BreadcrumbGenerator } from '@planone/shared/util-structured-data';

import { EmptyWatchlistComponent } from './empty-watchlist/empty-watchlist.component';
import { ItemCategoryPipe } from './page-watchlist/item-category.pipe';
import { PageWatchlistComponent } from './page-watchlist/page-watchlist.component';
import { WatchlistFilterButtonComponent } from './watchlist-filter-button/watchlist-filter-button.component';
import { WatchlistFilterDialogComponent } from './watchlist-filter-dialog/watchlist-filter-dialog.component';
import { WatchlistResultCountComponent } from './watchlist-result-count/watchlist-result-count.component';
import { ImageComponent } from './watchlist-results/watchlist-item/image/image.component';
import { WatchlistItemComponent } from './watchlist-results/watchlist-item/watchlist-item.component';
import { WatchlistResultsComponent } from './watchlist-results/watchlist-results.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        resolve: {
          watchlistPage: WatchlistResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        component: PageWatchlistComponent,
        data: {
          analyticsPageType: 'watchlist',
        },
      },
    ]),
    MatChipsModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    Bau365DataAccessFairDataModule,
    SharedUiElementsModule,
    SharedUtilPipelinesModule,
    Bau365UiShellModule,
    Bau365UiDateformattingModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureExportModule,
    SharedUtilFeatureFlagsModule,
  ],
  providers: [BreadcrumbHelper, BreadcrumbGenerator],
  declarations: [
    PageWatchlistComponent,
    WatchlistResultsComponent,
    WatchlistResultCountComponent,
    WatchlistItemComponent,
    EmptyWatchlistComponent,
    ImageComponent,
    WatchlistFilterButtonComponent,
    WatchlistFilterDialogComponent,
    ItemCategoryPipe,
  ],
})
export class Bau365FeatureWatchlistModule {}
